module.exports = __webpack_public_path__ + "7063cb0d624170380ea3ba24bf2d71c4.pdf";